import { Badge, Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import * as Styled from './styles'

interface StripeConnectionStatusProps {
  isConnected: boolean
}

export const StripeConnectionStatus = ({ isConnected }: StripeConnectionStatusProps): ReactElement => {
  const { t } = useTranslation()

  const label = isConnected
    ? t('settings.organization.card_payments.configuration.status_connected')
    : t('settings.organization.card_payments.configuration.status_disconnected')

  return (
    <Styled.StripeConnectionStatusWrapper>
      <Flex alignItems="center" gap={Spacing.S8}>
        <Badge color={isConnected ? 'success' : 'neutral'} type="dot" />
        <Text variant="bodySM">{label}</Text>
      </Flex>
    </Styled.StripeConnectionStatusWrapper>
  )
}
